import React from "react"

import styles from "./CoreParagraph.module.scss"

const CoreParagraph = ({ html, styleName }) => {
  const camelCase = require("camelcase")
  return html !== "<p></p>" ? (
    <section
      className={`${styles.paragraph} ${styles[camelCase("" + styleName)]}`}
      dangerouslySetInnerHTML={{ __html: html }}
    ></section>
  ) : null
}

export default CoreParagraph
